module.exports = __webpack_public_path__ + "img/icon_pingyin_deletion.1de8bc15.png";